export default "__VITE_ASSET__CWiLWiRi__"